import { useRequiredContext } from "@redotech/react-util/context";
import LinkIcon from "@redotech/redo-icons/link-01_filled.svg";
import MessageIcon from "@redotech/redo-icons/message-text-square-02.svg";
import SettingsIcon from "@redotech/redo-icons/settings-02.svg";
import TargetIcon from "@redotech/redo-icons/target-01.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { LinkPrimaryTab } from "@redotech/redo-web/arbiter-components/navigation/primary/redo-primary-nav";
import { PageNavigationEntry } from "@redotech/redo-web/arbiter-components/navigation/redo-side-navigation";
import { SecondaryNavigationData } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo, useContext } from "react";
import { useMatch } from "react-router-dom";

export function useAeoNavigation(): PageNavigationEntry | null {
  const routes = useRequiredContext(MerchantRoutesContext);
  const team = useContext(TeamContext);

  if (!team?.settings.aeo?.enabled) {
    return null;
  }

  const primaryTab: LinkPrimaryTab = {
    id: "aeo",
    hasNotification: false,
    UnfilledIcon: TargetIcon,
    FilledIcon: TargetIcon,
    type: "link",
    href: routes.aeoDashboardHref,
    pathRoot: routes.aeoBaseUrl,
    friendlyName: "AEO",
  };

  const secondaryNavigationData: SecondaryNavigationData = {
    id: "aeo",
    name: "AEO",
    NavContent: SecondaryAeoNavigation,
  };

  return { primaryTab, secondaryNavigationData };
}

const SecondaryAeoNavigation = memo(function SecondaryAeoNavigation() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const configureChildSelected = useMatch(`${routes.aeoConfigureHref}/*`);

  return (
    <>
      <RedoSecondaryNavItem
        action={{
          type: "link",
          href: routes.aeoDashboardHref,
        }}
        FilledIcon={TargetIcon}
        friendlyName="Dashboard"
        id="aeo-dashboard"
        UnfilledIcon={TargetIcon}
      />
      <RedoSecondaryNavItem
        action={{
          type: "link",
          href: routes.aeoPromptsHref,
        }}
        FilledIcon={MessageIcon}
        friendlyName="Prompts"
        id="aeo-prompts"
        UnfilledIcon={MessageIcon}
      />
      <RedoSecondaryNavItem
        action={{
          type: "link",
          href: routes.aeoSourcesHref,
        }}
        FilledIcon={LinkIcon}
        friendlyName="Sources"
        id="aeo-sources"
        UnfilledIcon={LinkIcon}
      />
      <RedoSecondaryNavItem
        action={{
          type: "link",
          href: routes.aeoConfigureHref,
        }}
        anyChildSelected={!!configureChildSelected}
        FilledIcon={SettingsIcon}
        friendlyName="Configure"
        id="aeo-configure"
        UnfilledIcon={SettingsIcon}
      />
    </>
  );
});
